import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomersCrmStatisticsAPI from '../../../api/CustomersCrmStatisticsAPI';

type Props = { timeRange: { start: string; end: string } };

function ConversionRateCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [rate, setRate] = useState<number | null>(null);
  const [totalAppointments, setTotalAppointments] = useState(0);
  const [appointmentsWithSale, setAppointmentsWithSale] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await CustomersCrmStatisticsAPI.getConversionRate({ startTime: timeRange.start, endTime: timeRange.end });
        const data = res.data;
        if (data) {
          setTotalAppointments(data.totalAppointments);
          setAppointmentsWithSale(data.appointmentsWithSale);
          setRate(data.conversionRatePercent);
        } else {
          setRate(0);
          setTotalAppointments(0);
          setAppointmentsWithSale(0);
        }
      } catch {
        setRate(0);
        setTotalAppointments(0);
        setAppointmentsWithSale(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  const displayRate = rate !== null ? `${Number(rate).toFixed(1)}%` : '—';

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{displayRate}</p>
      <p className="text-sm text-muted-foreground">
        {t('stats.conversion_rate') || 'Conversion rate'}
      </p>
      {(totalAppointments > 0 || appointmentsWithSale > 0) && (
        <p className="text-xs text-muted-foreground">
          {t('stats.conversion_rate.breakdown', { withSale: appointmentsWithSale, uniqueCustomers: totalAppointments })}
        </p>
      )}
    </div>
  );
}

export default ConversionRateCard;
